export default __webpack_public_path__ + "static/media/0O7C8932.48cd93e3.jpg";